import { ACCOUNTS_QUERY } from "@/apis/gql/apolloClient";
import type { AccountDetails } from "@/apis/gql/types";
import { useTenant } from "@/providers/session";
import { useQuery } from "@apollo/client";

export const useGetAllAccounts = () => {
  const { tenantId } = useTenant();
  const { data, error, loading, refetch } = useQuery<{
    accounts: AccountDetails[];
  }>(ACCOUNTS_QUERY, {
    variables: { tenantId },
  });

  return { accounts: data?.accounts ?? [], error, loading, refetch };
};
